import { render } from "./Context.vue?vue&type=template&id=e971854a"
import script from "./Context.vue?vue&type=script&lang=js"
export * from "./Context.vue?vue&type=script&lang=js"

import exportComponent from "/Users/greg/sites/queens/wp-content/themes/queens/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/context/Context.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e971854a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e971854a', __exports__)) {
    api.reload('e971854a', __exports__)
  }
  
  module.hot.accept("./Context.vue?vue&type=template&id=e971854a", () => {
    api.rerender('e971854a', render)
  })

}


export default __exports__